import { getSnippets } from '..'
import { Snippet } from './Snippet'

/**
 * snippets used as templates for tech issues should be defined in the project settings
 * and respect the following titles
 */

export const ISSUE_TPL_TITLE = 'Issue Template'
export const R_AND_D_TPL_TITLE = 'R&D Issue Template'

@store()
export class ProjectSnippets {
  constructor(private projectId: number) {}
  @lazy(async (ps) =>
    (await getSnippets(ps.projectId)).map((s) => new Snippet(s)),
  )
  snippets?: Snippet[]

  get issueTemplate() {
    // since undefined is used to indicate that the dependency branch is not loaded yet
    // we use null to indicate that the branch is loaded but empty
    if (this.snippets)
      return this.snippets.find((s) => s.title === ISSUE_TPL_TITLE) ?? null
  }

  get rAndDIssueTemplate() {
    if (this.snippets)
      return this.snippets.find((s) => s.title === R_AND_D_TPL_TITLE) ?? null
  }
}
